function stopEventPropagation(event) {
  event.preventDefault();
  event.persist();
  event.nativeEvent.stopImmediatePropagation();
  event.stopPropagation();
}

export { stopEventPropagation };
